<div class="auth-container">
  <div class="row auth-main no-gutters">
    <div class="col-xl-5 d-none d-xl-block px-0 left-col">
      <div class="image-wrapper"></div>
    </div>

    <div class="col-xl-7 col-12 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <h6 class="welcome-msg">¡BIENVENIDO!</h6>
          <p class="auth-signup-text text-muted">
            INGRESA LOS SIGUIENTES DATOS PARA ACCEDER A LA PLATAFORMA
          </p>
          <form #form="ngForm" class="validate-form">
            <div class="row">
              <div class="col-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>USUARIO</mat-label>
                  <input
                    #username="ngModel"
                    (keydown.enter)="login()"
                    [(ngModel)]="user.usr"
                    autocomplete="nope"
                    matInput
                    name="username"
                    required
                  />
                  <mat-icon class="material-icons-outlined p-3" matSuffix>
                    person
                  </mat-icon>
                </mat-form-field>
                <div *ngIf="username?.touched && username?.hasError('required')" class="custom-error-below">
                  <small class="text-danger">EL USUARIO ES REQUERIDO</small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>CONTRASEÑA</mat-label>
                  <!--suppress JSUnusedGlobalSymbols -->
                  <input
                    #password="ngModel"
                    (keydown.enter)="login()"
                    [(ngModel)]="user.password"
                    [type]="hide ? 'password' : 'text'"
                    autocomplete="nope"
                    matInput
                    name="password"
                    required
                  />
                  <mat-icon
                    (click)="hide = !hide"
                    class="material-icons-outlined pwd-toggle p-3"
                    matSuffix
                  >
                    {{ hide ? "visibility_off" : "visibility" }}
                  </mat-icon>
                </mat-form-field>
                <div *ngIf="password?.touched && password?.hasError('required')" class="custom-error-below">
                  <small class="text-danger">LA CONTRASEÑA ES REQUERIDA</small>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mb-5">
              <div class="form-check">
                <label class="form-check-label">
                  <input
                    autocomplete="nope"
                    class="form-check-input"
                    type="checkbox"
                    value=""
                  />
                  RECORDAR MIS DATOS
                  <span class="form-check-sign">
                    <span class="check"></span>
                  </span>
                </label>
              </div>
              <a class="txt1" routerLink="/authentication/forgot-password">
                ¿OLVIDASTE TU CONTRASEÑA?
              </a>
            </div>

            <div class="container-auth-form-btn">
              <div class="t-center">
                <button
                  (click)="login()"
                  [disabled]="!form.valid || acceptingLoginPolicies"
                  class="auth-form-btn"
                  color="primary"
                  mat-flat-button
                  type="button"
                >
                  ACCEDER A LA PLATAFORMA
                </button>
              </div>
            </div>

            <div *ngIf="loginPolicyTypes.length > 0">
              <app-privacy-policies-consent
                [(ngModel)]="loginPolicyAcceptances"
                [ngModelOptions]="{ standalone: true }"
                [profileType]="loginPolicyProfileType"
                [pendingTypes]="loginPolicyTypes"
                [modalOnly]="true"
                title="POLITICAS PENDIENTES"
                subtitle="ACEPTA LAS POLITICAS PENDIENTES PARA CONTINUAR CON EL INICIO DE SESION.">
              </app-privacy-policies-consent>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!--<div class="auth-container">-->
<!--  <div class="row auth-main">-->
<!--    <div class="col-sm-6 px-0 d-none d-sm-block">-->
<!--      <div class="left-img-wrapper">-->
<!--        <div-->
<!--          class="left-img"-->
<!--          style="background-image: url(assets/images/pages/bg-01.png)"-->
<!--        ></div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="col-sm-6 auth-form-section" style="background-color: #ffffff">-->
<!--      <div class="form-section">-->
<!--        <div class="auth-wrapper">-->
<!--          <h6 class="welcome-msg">¡BIENVENIDO!</h6>-->
<!--          <p class="auth-signup-text text-muted">-->
<!--            INGRESA LOS SIGUIENTES DATOS PARA ACCEDER A LA PLATAFORMA-->
<!--          </p>-->
<!--          <form #form="ngForm" class="validate-form">-->
<!--            <div class="row">-->
<!--              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">-->
<!--                <mat-form-field appearance="outline" class="example-full-width">-->
<!--                  <mat-label>USUARIO</mat-label>-->
<!--                  <input #username="ngModel" (keydown.enter)="login()"-->
<!--                         [(ngModel)]="user.usr"-->
<!--                         aria-autocomplete="none"-->
<!--                         autocomplete="nope"-->
<!--                         matInput-->
<!--                         name="username"-->
<!--                         required-->
<!--                  />-->
<!--                  <mat-icon class="material-icons-outlined p-3" matSuffix-->
<!--                  >person-->
<!--                  </mat-icon-->
<!--                  >-->
<!--                  <mat-temp-error*ngIf="username.hasError('required')"-->
<!--                  >EL USUARIO ES REQUERIDO-->
<!--                  </mat-temp-error>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-xl-12col-lg-12 col-md-12 col-sm-12 mb-2">-->
<!--                <mat-form-field appearance="outline" class="example-full-width">-->
<!--                  <mat-label>CONTRASEÑA</mat-label>-->
<!--                  <input #password="ngModel" (keydown.enter)="login()"-->
<!--                         [(ngModel)]="user.password"-->
<!--                         [type]="hide ? 'password' : 'text'"-->
<!--                         aria-autocomplete="none"-->
<!--                         autocomplete="nope"-->
<!--                         matInput-->
<!--                         name="password"-->
<!--                         required-->
<!--                  />-->
<!--                  <mat-icon-->
<!--                    (click)="hide = !hide"-->
<!--                    class="material-icons-outlined pwd-toggle p-3"-->
<!--                    matSuffix-->
<!--                  >-->
<!--                    {{ hide ? "visibility_off" : "visibility" }}-->
<!--                  </mat-icon-->
<!--                  >-->
<!--                  <mat-temp-error *ngIf="password.hasError('required')"-->
<!--                  >LA CONTRASEÑA ES REQUERIDA-->
<!--                  </mat-temp-error>-->
<!--                </mat-form-field>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="d-flex justify-content-between align-items-center mb-5">-->
<!--              <div class="form-check">-->
<!--                <label class="form-check-label">-->
<!--                  <input aria-autocomplete="none" autocomplete="nope" class="form-check-input" type="checkbox"-->
<!--                         value=""/>-->
<!--                  RECORDAR MIS DATOS-->
<!--                  <span class="form-check-sign">-->
<!--                    <span class="check"></span>-->
<!--                  </span>-->
<!--                </label>-->
<!--              </div>-->
<!--              <a class="txt1" routerLink="/authentication/forgot-password"-->
<!--              >¿OLVIDASTE TU CONTRASEÑA?</a-->
<!--              >-->
<!--            </div>-->
<!--            <div class="container-auth-form-btn">-->
<!--              <div style="text-align: center">-->
<!--                <button-->
<!--                  (click)="login()"-->
<!--                  [disabled]="!form.valid"-->
<!--                  class="auth-form-btn"-->
<!--                  color="primary"-->
<!--                  mat-flat-button-->
<!--                  type="button"-->
<!--                >-->
<!--                  ACCEDER A LA PLATAFORMA-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </form>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
